var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15707_2156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54633 7.09095L17.7535 1.58365C18.015 1.49481 18.299 1.63474 18.3878 1.8962C18.4232 2.00052 18.4232 2.11362 18.3878 2.21794L12.8806 18.4248C12.7918 18.6863 12.5078 18.8262 12.2463 18.7373C12.132 18.6985 12.0356 18.6196 11.9749 18.5152L8.11061 11.8667L1.45583 7.99659C1.21712 7.85777 1.13615 7.55171 1.27497 7.313C1.33565 7.20866 1.43204 7.12979 1.54633 7.09095ZM2.90811 7.68437L8.34662 10.8472L8.38196 10.7949L8.42462 10.7464L13.3744 5.79669C13.5696 5.60142 13.8862 5.60142 14.0815 5.79669C14.255 5.97025 14.2743 6.23968 14.1393 6.43455L14.0815 6.50379L9.13173 11.4535C9.10952 11.4757 9.08575 11.4954 9.06076 11.5126L12.2873 17.0627L17.1145 2.85695L2.90811 7.68437Z",
    fill: "#323130"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15707_2156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendemail);
export default __webpack_public_path__ + "static/media/resendemail.7aa2bc133b0cc0f6493345d40a7a71b0.svg";
export { ForwardRef as ReactComponent };